import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSitemap } from "@fortawesome/free-solid-svg-icons";
import "./organizationIcon.css";
const OrganizationIcon = () => {
  return <FontAwesomeIcon icon={faSitemap} />;
};

export default OrganizationIcon;
